import React from "react";

const FeedbackRating = ({
  value,
  onChange,
  discardWanted,
  onDiscardChange,
  discardReason,
  onDiscardReasonChange,
}) => {
  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="pb-4">
        <h3 className="text-lg font-medium text-dark py-2">
          Ekip arkadaşına geri bildirim ver
        </h3>
        <textarea
          className="w-full h-24 p-3 border-2 border-lineGray rounded-lg resize-none focus:outline-none min-h-[176px] bg-white text-grayy"
          placeholder="Geri bildiriminizi buraya yazın..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        ></textarea>
      </div>
      <div className="pb-4">
        <h3 className="text-lg font-medium text-dark py-2">
          Bu kişiyi takımdan çıkarmak ister misiniz?
        </h3>
        <div className="flex flex-col gap-4 md:flex-row justify-between md:items-center">
          <p className="text-sm text-grayy pb-2 max-w-[446px]">
            Eğer %50 ve daha fazla takımdan çıksın oyu alırsa arkadaşınız
            ekipten otomatik olarak çıkartılacaktır.
          </p>
          <div className="flex items-center gap-6 min-[233px]">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="remove"
                value="yes"
                checked={discardWanted === true}
                onChange={() => onDiscardChange(true)}
                className="hidden"
              />
              <div
                className={`w-5 h-5 border-2 rounded-full flex items-center justify-center transition-all ${
                  discardWanted === true
                    ? "border-darkerGreen"
                    : "border-gray-400"
                }`}
              >
                {discardWanted === true && (
                  <div className="w-2.5 h-2.5 bg-darkerGreen rounded-full"></div>
                )}
              </div>
              <span className="ml-2 text-dark text-sm">Evet</span>
            </label>

            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="remove"
                value="no"
                checked={discardWanted === false}
                onChange={() => onDiscardChange(false)}
                className="hidden"
              />
              <div
                className={`w-5 h-5 border-2 rounded-full flex items-center justify-center transition-all ${
                  discardWanted === false
                    ? "border-gray-500"
                    : "border-gray-400"
                }`}
              >
                {discardWanted === false && (
                  <div className="w-2.5 h-2.5 bg-gray-500 rounded-full"></div>
                )}
              </div>
              <span className="ml-2 text-dark text-sm">Hayır</span>
            </label>
          </div>
        </div>
      </div>
      {discardWanted === true && (
        <div className="pb-4">
          <h3 className="text-lg font-medium text-dark py-2">
            Neden takımdan ayrılmasını istiyorsunuz?
          </h3>
          <textarea
            className="w-full h-24 p-3 border-2 border-lineGray rounded-lg resize-none focus:outline-none min-h-[176px] bg-white text-grayy"
            placeholder="Burayı doldurmanız zorunludur *"
            value={discardReason}
            onChange={(e) => onDiscardReasonChange(e.target.value)}
          ></textarea>
        </div>
      )}
    </div>
  );
};

export default FeedbackRating;
